import { Slot } from '@radix-ui/react-slot'

import { cn } from '~/utils/cn'
import { type VariantProps, tv } from '~/utils/tv'

type BodyProps = React.ComponentPropsWithRef<'p'> &
  VariantProps<typeof bodyVariants> & {
    asChild?: boolean
  }

const bodyVariants = tv({
  base: 'font-sans text-threeandhalfpulse/small tracking-normal no-underline',
  variants: {
    variant: {
      'default-bold': null,
      'underline-bold': null,
      'default-semibold': null,
      'underline-semibold': null,
      'default-regular': 'font-normal',
    },
  },
  compoundVariants: [
    {
      variant: ['default-bold', 'underline-bold'],
      class: 'font-bold',
    },
    {
      variant: ['default-semibold', 'underline-semibold'],
      class: 'font-semibold',
    },
    {
      variant: ['underline-bold', 'underline-semibold'],
      class: 'underline',
    },
  ],
  defaultVariants: {
    variant: 'default-bold',
  },
})

function Body({ variant, asChild, ...props }: BodyProps) {
  const Comp = asChild ? Slot : 'p'

  return (
    <Comp
      {...props}
      className={cn(
        bodyVariants({
          variant,
        })
      )}
    />
  )
}

export { Body }
export type { BodyProps }
